import pluralize from 'pluralize'

export const plur = (number, string) => `${number} ${pluralize(string, number)}`
